import { IGroupQuery } from '../interfaces/group.query.interface';
import { GroupAvatar } from './group-avatar';

export class Group {
    static props_to_search = ['name'];

    static label_plural = 'Groups';
    static label_singular = 'Group';

    id: string;
    name: string;
    image?: GroupAvatar;
    file?: File;
    memberCount: number;
    isFavourite: boolean;
    groupAdmins: {
        userId: string;
    }[];

    contentNodeId: string;
    isCurrentUserAdmin: boolean;

    constructor(query?: IGroupQuery) {
        if (query) {
            this.id = query.id ? query.id.toString() : null;
            this.name = query.name;
            this.memberCount = query.member_count;
            this.isFavourite = query.is_favourite;
            this.groupAdmins = query.group_admins.map((item) => {
                return { userId: item.user_id.toString() };
            });

            this.image = query.image ? new GroupAvatar(query.image) : null;
        }

        this.contentNodeId = null;
        this.isCurrentUserAdmin = false;
    }
}
